import isBoolean from 'lodash/isBoolean';
import memoize from 'lodash/memoize';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import * as Actions from '../../actions';
import * as Constants from '../../constants';
import * as Utils from '../../utils';
import GridItem from '../lib/GridItem/GridItem';
import RightsChecker from '../RightsChecker/RightsChecker';

function routeToPage(router, path) {
  router.push(path);
}

const memoizedItemOnClickFunction = memoize((url, router) => {
  return () => routeToPage(router, url);
});

/**
 * CatalogGridItem provides generalized functionality and settings for rendering
 * T3 catalog GridItems. AlbumGridItem, ArtistGridItem, PlaylistGridItem and
 * TrackGridItem all use this component for their rendering. The station grid
 * items are the only ones that do not.
 *
 * See lib/GridItem for additional available props.
 */
class CatalogGridItem extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    pandoraType: PropTypes.string,
    playResumeSource: PropTypes.func,
    rightsCheckerFunc: PropTypes.func.isRequired,
    pauseTrack: PropTypes.func,
    isPlayingCurrently: PropTypes.bool,
    isPaused: PropTypes.bool,
    isUnavailable: PropTypes.bool,
    isRadioOnly: PropTypes.bool,
    isRetired: PropTypes.bool,
    isExplicit: PropTypes.bool,
    isClean: PropTypes.bool,
    dominantColor: PropTypes.string,
    collectedTrackCount: PropTypes.number,
    hidePlayButton: PropTypes.bool,
    blankItem: PropTypes.bool,
    sourceCardMenuItems: PropTypes.array,
    imgUrl: PropTypes.string,
    itemOnclick: PropTypes.func,
    itemOnclickUrl: PropTypes.string,
    forceRestartSourceIfPlaying: PropTypes.bool,
    router: PropTypes.object.isRequired,
    isCircle: PropTypes.bool,
  };

  static defaultProps = {
    hidePlayButton: false,
  };

  onPlayClick = () => {
    const { collectedTrackCount, forceRestartSourceIfPlaying } = this.props;
    this.props.rightsCheckerFunc();

    let { id, pandoraType } = this.props;
    if (collectedTrackCount) {
      id = Utils.SourceType.getCollectedAlbumTracksId(id);
      pandoraType = Constants.SourceTypes.PandoraTypes.COLLECTED_ALBUM_TRACKS;
    }

    this.props.playResumeSource({
      id,
      pandoraType,
      forceRestartSourceIfPlaying,
    });
  };

  render() {
    if (this.props.blankItem) {
      return <GridItem {...this.props} isPlaceholder={true} />;
    }

    if (isBoolean(this.props.isPlayingCurrently)) {
      const playButtonOnclick = !this.props.hidePlayButton ? this.onPlayClick : null;
      const { itemOnclickUrl } = this.props;
      return (
        <GridItem
          playButtonOnclick={playButtonOnclick}
          pauseButtonOnclick={this.props.pauseTrack}
          isPlaying={this.props.isPlayingCurrently && !this.props.isPaused && !this.props.isRetired}
          isPaused={this.props.isPaused}
          isCircle={this.props.isCircle}
          isExplicit={this.props.isExplicit}
          isClean={this.props.isClean}
          isDisabled={this.props.isRadioOnly || this.props.isUnavailable || this.props.isRetired}
          itemOnclick={
            itemOnclickUrl && memoizedItemOnClickFunction(itemOnclickUrl, this.props.router)
          }
          qaMainText={Constants.QATags.BGITF}
          qaSecondText={Constants.QATags.BGITS}
          qaThirdText={Constants.QATags.BGITT}
          {...this.props}
        />
      );
    }
    return (
      <GridItem
        isCircle={this.props.isCircle}
        itemOnclick={
          this.props.itemOnclickUrl &&
          memoizedItemOnClickFunction(this.props.itemOnclickUrl, this.props.router)
        }
        {...this.props}
      />
    );
  }
}

const mapDispatchToProps = {
  playResumeSource: Actions.UseCases.playResumeSource,
  pauseTrack: Actions.UseCases.pauseTrack,
};

export default withRouter(RightsChecker(connect(null, mapDispatchToProps)(CatalogGridItem)));
